import React from 'react';
import BaseGrid from './BaseGrid';

class FileToLargeContent extends BaseGrid {
  render() {
    return (
      <div>
        <p>{this.props.moduleContentText}</p>
        <BaseGrid
          columns={this.props.columns} 
          data={this.props.data} 
          className={this.props.className}
          rowHeight={this.props.rowHeight}
        />
      </div>
    );
  }
}

export default FileToLargeContent;
